// Translation
import { createI18n } from "vue-i18n";
import { UserPreferencesService } from "@/services/UserPreferencesService";
import i18n_en from "@/locales/en.json";
import i18n_fr from "@/locales/fr.json";

const userPreferencesService = UserPreferencesService.INSTANCE;
const i18n = createI18n({
  legacy: false,
  locale: userPreferencesService.getUserPrefLocale(),
  allowComposition: true, // https://vue-i18n.intlify.dev/guide/migration/vue3#how-to-migration
  messages: {
    en: i18n_en,
    fr: i18n_fr,
  },
});
export default i18n;
